import { FiLoader, FiPlus } from "react-icons/fi";
import { ReactNode, MouseEventHandler } from "react";

interface ButtonProps {
  title?: string;
  icon?: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
}

function Button({
  title,
  icon,
  className,
  onClick,
  type,
  loading,
}: ButtonProps) {
  return (
    <button
      type={type ?? "button"}
      disabled={loading}
      onClick={onClick}
      className={
        "inline-flex w-full items-center justify-center rounded bg-primary px-4 py-3 text-center font-medium text-white hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out " +
        (className ?? "")
      }
    >
      {!loading ? (
        <div className="flex items-center gap-2">
          {icon ?? <FiPlus size={20} />}
          {title ?? ""}
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <FiLoader size={20} className="animate-spin" /> {title ?? ""}
        </div>
      )}
    </button>
  );
}

export default Button;
